import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import FormContainer from './FormContainer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { useState } from 'react';
import useApi from '../hooks/ApiHook';
import useToast from '../hooks/ToastHook';

const passwordRules = [{
  key: 1,
  description: '8 caracteres',
  validation: (password) => password.length > 7
}, {
  key: 2,
  description: '1 letra maiúscula',
  validation: (password) => /[A-Z]/.test(password)
}, {
  key: 3,
  description: '1 letra minúscula',
  validation: (password) => /[a-z]/.test(password)
}, {
  key: 4,
  description: '1 caractere especial',
  validation: (password) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password)
}]

const NewPassword = () => {
  const navigate = useNavigate();
  const api = useApi();
  const toast = useToast();
  const [ params ] = useSearchParams();
  const [ password, setPassword ] = useState('');
  const [ passwordConfirm, setPasswordConfirm ] = useState('');
  const [ validPassword, setValidPassword ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const onChangeValidationState = valid => {
    setValidPassword(valid);
  }

  const submit = async e => {
    try {
      e.preventDefault();
      setLoading(true);
      await api.post('change-password/new-password', { password, uuid: params.get('uuid') });
      toast.showSuccess('Senha alterada com sucesso!');
      navigate('/');
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <FormContainer>
      <div className='text-3xl font-semibold text-black-alpha-90 mb-2'>
        Vamos redefinir a sua senha
      </div>
			<div className="mb-4 text-700">
        Insira abaixo sua nova senha
			</div>
      <form onSubmit={submit}>
        <div className="field">
          <label>Nova senha</label>
          <Password 
            className='w-full' 
            inputClassName='w-full' 
            feedback={false} 
            required
            value={password}
            onChange={e => setPassword(e.target.value)}/>
        </div>
        <div className="field">
          <label>Confirme a nova senha</label>
          <Password 
            className='w-full' 
            inputClassName={`w-full ${password !== passwordConfirm && 'p-invalid'}`} 
            feedback={false} 
            required
            value={passwordConfirm}
            onChange={e => setPasswordConfirm(e.target.value)}/>
        </div>
        <PasswordFeedback password={password} onChangeState={onChangeValidationState}/>
        <div className="field">
          <Button 
            className='w-full' 
            label='Enviar'
            loading={loading}
            disabled={!validPassword || password !== passwordConfirm}/>
        </div>
        <div clclassNameass="field">
          <Button 
            className='w-full' 
            label='Cancelar' 
            severity="secondary"
            type='button'
            onClick={() => navigate('/')}/>
        </div>
      </form>
    </FormContainer>
  );
}

function PasswordFeedback({ password = 'leonardo', onChangeState }) {

  const validations = passwordRules.map(r => ({ description: r.description, valid: r.validation(password), key: r.key }));
  const allValid = !validations.some(v => !v.valid);
  onChangeState(allValid);

  return (
    <Panel className='mb-3'>
      {validations.map(v => (
        <div className={`flex mb-3 text-sm ${v.valid && 'text-green-700 font-semibold'}`} key={v.key}>
          <div className='flex-grow-1'>{v.description}</div>
          <div><i className={`pi ${v.valid ? 'pi-check' : 'pi-times'}`}></i></div>
        </div>
      ))}
    </Panel>
  );
}

export default NewPassword;